import { render } from "./dashboardView.vue?vue&type=template&id=74f000be&scoped=true"
import script from "./dashboardView.vue?vue&type=script&lang=js"
export * from "./dashboardView.vue?vue&type=script&lang=js"

import "./dashboardView.vue?vue&type=style&index=0&id=74f000be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74f000be"]])

export default __exports__